export default __webpack_public_path__ + "static/media/diagram-y-new.8c254553.png";